import SettingsEllipsisBold from './SettingsEllipsisBold';

export default SettingsEllipsisBold;
